import { render, staticRenderFns } from "./DeviceModelBlock.vue?vue&type=template&id=2203673c&"
import script from "./DeviceModelBlock.vue?vue&type=script&lang=js&"
export * from "./DeviceModelBlock.vue?vue&type=script&lang=js&"
import style0 from "./DeviceModelBlock.vue?vue&type=style&index=0&id=2203673c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports